// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MuiDialog-paper {
  max-height: calc(100% - 209px);
  max-width: 500px;
}

.MuiDataGrid-columnHeaderTitle {
  font-size: 16px !important;
  font-weight: 600 !important;
  color: black !important;
}

.MuiDialogActions-root {
  justify-content: flex-start !important;
}

.MuiDataGrid-columnHeaders {
  border: none !important;
}

.MuiDataGrid-root {
  border: none !important;
  box-shadow: 0px 3px 5px 0px rgba(0, 0, 0, 0.1) !important;
}

.MuiDataGrid-root .MuiDataGrid-row {
  min-height: 40px !important;
  background: rgb(255, 255, 255);
  box-shadow: rgb(0 0 0 / 10%) 0px 1px 4px !important ;
  border-radius: 2px !important;
  margin-bottom: 3px !important;
}

.MuiDataGrid-root
  .MuiDataGrid-row:not(.MuiDataGrid-row--dynamicHeight)
  > .MuiDataGrid-cell {
  min-height: 40px !important;
}

.MuiDataGrid-footerContainer {
  border: none !important;
}

.MuiDivider-root {
  border: none !important;
}

.MuiButton-root.Mui-disabled {
  color: #9b9b9bb5 !important;
  box-shadow: none !important;
  text-transform: uppercase;
  background-color: rgba(0, 0, 0, 0.04) !important;
  font-weight: 400 !important;
  letter-spacing: 0.5px;
  padding: 4px 16px;
  border-radius: 2px;
  font-size: 14px;
}

.MuiTablePagination-root .MuiTablePagination-selectLabel {
  margin-bottom: 0rem !important;
}

.MuiTablePagination-displayedRows {
  margin-bottom: 0rem !important;
}

.requestButton {
  color: #ffffff !important;
  box-shadow: none !important;
  background-color: #008080 !important;
  font-weight: 400 !important;
  font-size: 12px !important;
  text-transform: unset !important;
  min-width: 11.5em !important;
}

.requestButton:hover {
  background-color: #006d6d !important;
}

.MuiDataGrid-root .MuiDataGrid-columnSeparator {
  display: none !important;
}

.headerSearchFlex {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  /* margin-bottom: 14px; */
}

.MuiDataGrid-root
  .MuiDataGrid-row:not(.MuiDataGrid-row--dynamicHeight)
  > .MuiDataGrid-cell {
  width: 0px !important;
}

.MuiOutlinedInput-root {
  /* height: 31px !important; */
}

.Mui-focused {
  color: #008080 !important;
}

.MuiOutlinedInput-input .Mui-focused :focus {
  outline: 1px solid #008080 !important;
}

.MuiDataGrid-main {
  margin-bottom: 1.5rem;
}

.MuiDataGrid-virtualScrollerContent {
  height: unset !important;
}

.MuiTablePagination-toolbar {
  display: none !important;
}

.active > .page-link,
.page-link.active {
  background-color: #53565a !important;
  border-color: #53565a !important;
}

.css-v0l51d-MuiDataGrid-footerContainer {
  display: none !important;
}
`, "",{"version":3,"sources":["webpack://./src/pages/homeDashboard/components/Modals/TOSModal/modalTOS.css"],"names":[],"mappings":"AAAA;EACE,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;EAC1B,2BAA2B;EAC3B,uBAAuB;AACzB;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;EACvB,yDAAyD;AAC3D;;AAEA;EACE,2BAA2B;EAC3B,8BAA8B;EAC9B,oDAAoD;EACpD,6BAA6B;EAC7B,6BAA6B;AAC/B;;AAEA;;;EAGE,2BAA2B;AAC7B;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,2BAA2B;EAC3B,2BAA2B;EAC3B,yBAAyB;EACzB,gDAAgD;EAChD,2BAA2B;EAC3B,qBAAqB;EACrB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;EAC3B,oCAAoC;EACpC,2BAA2B;EAC3B,0BAA0B;EAC1B,gCAAgC;EAChC,4BAA4B;AAC9B;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;;;EAGE,qBAAqB;AACvB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;;EAEE,oCAAoC;EACpC,gCAAgC;AAClC;;AAEA;EACE,wBAAwB;AAC1B","sourcesContent":[".MuiDialog-paper {\n  max-height: calc(100% - 209px);\n  max-width: 500px;\n}\n\n.MuiDataGrid-columnHeaderTitle {\n  font-size: 16px !important;\n  font-weight: 600 !important;\n  color: black !important;\n}\n\n.MuiDialogActions-root {\n  justify-content: flex-start !important;\n}\n\n.MuiDataGrid-columnHeaders {\n  border: none !important;\n}\n\n.MuiDataGrid-root {\n  border: none !important;\n  box-shadow: 0px 3px 5px 0px rgba(0, 0, 0, 0.1) !important;\n}\n\n.MuiDataGrid-root .MuiDataGrid-row {\n  min-height: 40px !important;\n  background: rgb(255, 255, 255);\n  box-shadow: rgb(0 0 0 / 10%) 0px 1px 4px !important ;\n  border-radius: 2px !important;\n  margin-bottom: 3px !important;\n}\n\n.MuiDataGrid-root\n  .MuiDataGrid-row:not(.MuiDataGrid-row--dynamicHeight)\n  > .MuiDataGrid-cell {\n  min-height: 40px !important;\n}\n\n.MuiDataGrid-footerContainer {\n  border: none !important;\n}\n\n.MuiDivider-root {\n  border: none !important;\n}\n\n.MuiButton-root.Mui-disabled {\n  color: #9b9b9bb5 !important;\n  box-shadow: none !important;\n  text-transform: uppercase;\n  background-color: rgba(0, 0, 0, 0.04) !important;\n  font-weight: 400 !important;\n  letter-spacing: 0.5px;\n  padding: 4px 16px;\n  border-radius: 2px;\n  font-size: 14px;\n}\n\n.MuiTablePagination-root .MuiTablePagination-selectLabel {\n  margin-bottom: 0rem !important;\n}\n\n.MuiTablePagination-displayedRows {\n  margin-bottom: 0rem !important;\n}\n\n.requestButton {\n  color: #ffffff !important;\n  box-shadow: none !important;\n  background-color: #008080 !important;\n  font-weight: 400 !important;\n  font-size: 12px !important;\n  text-transform: unset !important;\n  min-width: 11.5em !important;\n}\n\n.requestButton:hover {\n  background-color: #006d6d !important;\n}\n\n.MuiDataGrid-root .MuiDataGrid-columnSeparator {\n  display: none !important;\n}\n\n.headerSearchFlex {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  align-items: center;\n  /* margin-bottom: 14px; */\n}\n\n.MuiDataGrid-root\n  .MuiDataGrid-row:not(.MuiDataGrid-row--dynamicHeight)\n  > .MuiDataGrid-cell {\n  width: 0px !important;\n}\n\n.MuiOutlinedInput-root {\n  /* height: 31px !important; */\n}\n\n.Mui-focused {\n  color: #008080 !important;\n}\n\n.MuiOutlinedInput-input .Mui-focused :focus {\n  outline: 1px solid #008080 !important;\n}\n\n.MuiDataGrid-main {\n  margin-bottom: 1.5rem;\n}\n\n.MuiDataGrid-virtualScrollerContent {\n  height: unset !important;\n}\n\n.MuiTablePagination-toolbar {\n  display: none !important;\n}\n\n.active > .page-link,\n.page-link.active {\n  background-color: #53565a !important;\n  border-color: #53565a !important;\n}\n\n.css-v0l51d-MuiDataGrid-footerContainer {\n  display: none !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
